import { LogOut, User } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { cn } from '@/lib/utils'

const menuItems = [
  { id: 'monitor', label: '直播监控', path: '/monitor' },
  { id: 'schedule-rules', label: '预约规则', path: '/schedule-rules' },
  { id: 'settings', label: '系统设置', path: '/settings' },
]

export default function Sidebar() {
  const { user, signOut } = useAuth()

  return (
    <aside className="h-[100dvh] w-[216px] shrink-0 border-r border-[var(--structural-border)] bg-[var(--console-ink)]">
      <div className="flex h-full flex-col py-[22px]">
        <div className="flex items-center gap-2.5 px-5 pb-[22px]">
          <div className="flex h-[26px] w-[26px] items-center justify-center rounded-md bg-[var(--action-fill)] font-mono text-[13px] font-semibold text-[var(--action-contrast)]">
            U
          </div>
          <div className="min-w-0">
            <p className="truncate text-[13px] font-bold leading-tight text-[var(--text-ink)]">直播监控后台</p>
            <p className="mt-0.5 font-mono text-[10px] tracking-[0.1em] text-[var(--text-muted)]">BILIBILI OPS</p>
          </div>
        </div>

        <nav className="flex flex-col gap-0.5 px-3" aria-label="主导航">
          {menuItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                cn(
                  'flex min-h-11 items-center gap-2.5 rounded-md border-l-2 px-3 text-sm transition-colors',
                  isActive
                    ? 'border-[var(--action-blue)] bg-[var(--panel-raised)] font-medium text-[var(--text-ink)]'
                    : 'border-transparent text-[var(--text-muted)] hover:bg-[var(--surface-hover)] hover:text-[var(--text-soft)]'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    aria-hidden="true"
                    className={cn(
                      'h-1.5 w-1.5 rounded-full',
                      isActive ? 'bg-[var(--action-fill)]' : 'bg-[var(--border-control)]'
                    )}
                  />
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto border-t border-[var(--border-subtle)] px-5 pt-4">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-[var(--structural-border)] bg-[var(--panel-white)]">
              <User className="h-4 w-4 text-[var(--text-muted)]" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-xs text-[var(--text-soft)]">{user?.email || '当前用户'}</p>
              <p className="mt-0.5 flex items-center gap-1.5 text-[10px] text-[var(--text-muted)]">
                <span className="h-1.5 w-1.5 rounded-full bg-[var(--status-healthy)]" />
                已登录
              </p>
            </div>
            <button
              type="button"
              onClick={() => void signOut()}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-[var(--text-muted)] transition-colors hover:bg-[var(--panel-raised)] hover:text-[var(--text-ink)]"
              aria-label="退出登录"
              title="退出登录"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </aside>
  )
}
